
import React, { useState, useEffect, useCallback } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  TransformAttributes,
  Condition,
  Creature,
  CreatureGift,
  SENSES,
  Skill,
  SKILLS,
  Tool,
} from "@dndModels";
import { 
  DAMAGE_TYPES,
  PROFICIENCY_OPTIONS
} from "@dndModels/Constants";
import { AbilityScoreType, DamageType } from "@dndModels/Types";

import DandDAPI from "@utilities/smart_api";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import StringBox from "@components/input/strings/StringBox";
import CheckBox from "@components/input/CheckBox";
import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";
import LoadingBox from "@components/input/LoadingBox";
import FlexBox from '@components/layout/FlexBox';
import AttributesInput from './AttributesInput';
import InheritAttributesInput from './InheritAttributesInput';

interface Props {
  attributes: TransformAttributes;
  disabled: boolean;
  use_creature: boolean;
  onChange: () => void;
}

const api = DandDAPI.getInstance();

export default function TransformAttributesInput({
  attributes,
  disabled,
  use_creature,
  onChange
}: Props) {

  return (
    <FlexBox direction="column">
      <FlexBox xs_expand={0} className="header centered">Transform Attributes</FlexBox>
      <FlexBox>
        <AttributesInput
          attributes={attributes.attributes}
          disabled={disabled}
          onChange={onChange}
        />
      </FlexBox>
      <FlexBox xs_expand={0} className="header centered">Attributes from Target</FlexBox>
      <FlexBox>
        <InheritAttributesInput
          attributes={attributes.from_target}
          disabled={disabled}
          onChange={onChange}
        />
      </FlexBox>
      { use_creature && 
        <>
          <FlexBox xs_expand={0} className="header centered">Attributes from Creature</FlexBox>
          <FlexBox>
            <InheritAttributesInput
              attributes={attributes.from_creature}
              disabled={disabled}
              onChange={onChange}
            />
          </FlexBox>
        </>
      }
    </FlexBox>
  )
}
